export default __webpack_public_path__ + "static/media/button-apple-store.1094b4ab.svg";